import React from "react";
import ForgotPasswordContainer from "../../../containers/Auth/ForgotPassword";

const ForgotPasswordScreen = ({ listConfig }) => {
  return <ForgotPasswordContainer listConfig={listConfig} />;
};
export default ForgotPasswordScreen;
